import type { IconProps } from './types';

export function Legging({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M88 36 Q128 32 168 36 Q168 48 168 60 Q166 142 164 224 Q154 228 144 224 Q136 160 128 96 Q120 160 112 224 Q102 228 92 224 Q90 142 88 60 Q88 48 88 36 Z" />
      <path d="M88 60 Q128 64 168 60" />
    </svg>
  );
}
